export const CLINICAL_STUDY_ACCOUNT_TYPE = 'clinical_study';

export const CLINICAL_PATHS = {
  root: '/clinical',
  programInsights: '/clinical/program-insights',
  studyInsights: '/clinical/study-insights',
  retentionInsights: '/clinical/retention-insights',
  reportableEvents: '/clinical/reportable-events',
};

export const isClinicalAccountUser = (user) => {
  if (!user) {
    return false;
  }

  if (user.current_profile_type === 'ClinicalUser') {
    return true;
  }

  return user.current_profile_type === 'AccountAdmin' && user.account?.account_type === CLINICAL_STUDY_ACCOUNT_TYPE;
};
